import styled, {css} from "styled-components";
import {getTextColor} from "../../../common/generic-react.functions.js";
import {ButtonContainer} from "../button/button.styles.js";
export const PaginationContentContainer = styled.ul.withConfig({
  displayName: "paginationstyles__PaginationContentContainer",
  componentId: "sc-178bo92-0"
})(["", " .pagination__divider{", "}"], {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  listStyleType: "none",
  margin: "0px",
  width: "100%",
  maxWidth: "100%"
}, {
  display: "flex",
  alignItems: "center",
  marginLeft: "0.25rem",
  marginRight: "0.25rem"
});
function getActiveSelect() {
  return css(["", ";color:", ";"], {
    backgroundColor: "var(--primaryColor)"
  }, getTextColor("var(--primaryColor)"));
}
export const PaginationItemContainer = styled.li.withConfig({
  displayName: "paginationstyles__PaginationItemContainer",
  componentId: "sc-178bo92-1"
})(["", " ", "{", " ", " &:not:disabled{", "}}"], {
  display: "flex",
  alignItems: "center",
  marginLeft: "0.5rem",
  marginRight: "0.5rem"
}, ButtonContainer, {
  height: "2rem",
  width: "2rem",
  padding: "0px",
  borderWidth: "1px",
  borderStyle: "solid",
  "--tw-border-opacity": "1",
  borderColor: "rgba(42, 57, 78, var(--tw-border-opacity))"
}, ({
  active
}) => active && getActiveSelect(), {
  "--tw-text-opacity": "1",
  color: "rgba(42, 57, 78, var(--tw-text-opacity))",
  "--tw-bg-opacity": "1",
  backgroundColor: "rgba(255, 255, 255, var(--tw-bg-opacity))"
});
export const PaginationContainer = styled.nav.withConfig({
  displayName: "paginationstyles__PaginationContainer",
  componentId: "sc-178bo92-2"
})(["", " ", "{", "}"], ({
  disabled
}) => disabled && {
  opacity: "0.5"
}, PaginationItemContainer, ({
  disabled
}) => !disabled && {
  cursor: "pointer"
});
